/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { Optional, EnumPosition } from '@/types';
import {
  PlayerClub,
  ResponseArmaEquipoGrabar,
  ResponseGetInitDraftTeam,
} from '@/types/team';
import { TACTICS_ARR } from '@/utils';

const TACTICS_STYLES = {
  BASE: 'flex justify-center relative',
  DEF_DEL: 'mt-5 lg:mt-3',
  VOL: 'mt-4 lg:mt-3',
};

export const DELETE_ADD_ORDER = [
  EnumPosition.DEF,
  EnumPosition.MID,
  EnumPosition.FWD,
] as const;

export const TACTIC_POSITION_STYLES = {
  1: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-8`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-4 lg:space-x-11`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-7 lg:space-x-20`,
  },
  2: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-8`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-7 lg:space-x-11`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-7 lg:space-x-11`,
  },
  3: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-6 lg:space-x-8`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-4 lg:space-x-8`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-6 lg:space-x-8`,
  },
  4: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-8`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-2 lg:space-x-8`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-8`,
  },
  5: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-6 lg:space-x-10`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-2 lg:space-x-5`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-6 lg:space-x-16`,
  },
  6: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-2 lg:space-x-6`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-7 lg:space-x-12`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-7 lg:space-x-20`,
  },
  7: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-7 lg:space-x-12`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-7 lg:space-x-12`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-11`,
  },
  8: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-8`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-7 lg:space-x-16`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-4 lg:space-x-12`,
  },
  9: {
    DEF: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-2 lg:space-x-7`,
    VOL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.VOL} space-x-7 lg:space-x-16`,
    DEL: `${TACTICS_STYLES.BASE} ${TACTICS_STYLES.DEF_DEL} space-x-6 lg:space-x-14`,
  },
};

export type ErrorConvertionTactic = {
  message: string;
};

export type TeamInfo = {
  players: PlayerClub[];
  // eslint-disable-next-line no-use-before-define
  tactic: TacticDescriptor;
};

export const isConvertionError = (
  result: ErrorConvertionTactic | TeamInfo
): result is ErrorConvertionTactic => {
  return (result as ErrorConvertionTactic).message !== undefined;
};

/* 
  [4, 4, 2],
  [4, 3, 3],
  [3, 4, 3],
  [4, 5, 1],
  [3, 5, 2],
  [5, 3, 2],
  [3, 3, 4],
  [4, 2, 4],
  [5, 2, 3],
*/

export const EnumTactic = {
  _442: { id: 1, arrDescription: TACTICS_ARR[1] },
  _433: { id: 2, arrDescription: TACTICS_ARR[2] },
  _343: { id: 3, arrDescription: TACTICS_ARR[3] },
  _451: { id: 4, arrDescription: TACTICS_ARR[4] },
  _352: { id: 5, arrDescription: TACTICS_ARR[5] },
  _532: { id: 6, arrDescription: TACTICS_ARR[6] },
  _334: { id: 7, arrDescription: TACTICS_ARR[7] },
  _424: { id: 8, arrDescription: TACTICS_ARR[8] },
  _523: { id: 9, arrDescription: TACTICS_ARR[9] },
} as const;

export class TacticDescriptor {
  public arrLinesDescription: number[];
  constructor(arrLinesDescription: number[]) {
    this.arrLinesDescription = arrLinesDescription;
  }

  /**
   * EG: in the tactic 442
   * The line of midfielders starts at index 5
   */
  calcStartOfLine(pos: EnumPosition): number {
    let ix = 0;
    for (const posIt of [
      EnumPosition.GK,
      EnumPosition.DEF,
      EnumPosition.MID,
      EnumPosition.FWD,
    ]) {
      if (pos === posIt) {
        return ix;
      }
      ix += this.calcLineSize(posIt);
    }
    throw new Error('no valido');
  }

  /**
   * EG:
   * For tactic 442 in the defenders position the size will be 4
   */
  calcLineSize(pos: EnumPosition) {
    if (pos === EnumPosition.GK) {
      return 1;
    }
    return this.arrLinesDescription[pos - 2];
  }

  calcEndOfLine(pos: EnumPosition) {
    let ix = 0;
    for (const posIt of [
      EnumPosition.GK,
      EnumPosition.DEF,
      EnumPosition.MID,
      EnumPosition.FWD,
    ]) {
      ix += this.calcLineSize(posIt);

      if (pos === posIt) {
        return ix;
      }
    }
    throw new Error('Invalid position');
  }

  static byId(tacticId: number) {
    const eTact = Object.values(EnumTactic).filter((element) => {
      return element.id === tacticId;
    })[0];
    return new TacticDescriptor(eTact.arrDescription);
  }
}

// type validTacticId = keyof [typeof TACTICS_ARR];

export function convertTeamTactic(
  sourceTeam: TeamInfo,
  targetTeamTactic: TacticDescriptor
): TeamInfo | ErrorConvertionTactic {
  const newTeam = buildEmptyTeam(targetTeamTactic);

  // staring lineup
  for (const posIt of [
    EnumPosition.GK,
    EnumPosition.DEF,
    EnumPosition.MID,
    EnumPosition.FWD,
  ]) {
    const sourceLine = extractLine(sourceTeam, posIt);
    const lineStart = targetTeamTactic.calcStartOfLine(posIt);
    const lineSize = targetTeamTactic.calcLineSize(posIt);
    if (sourceLine.length > lineSize) {
      return {
        message: 'Error de conversión de táctica',
      };
    }
    const sourceLineReordered = sourceLine.map((elem, ix) => {
      return {
        ...elem,
        orden: ix + lineStart,
      };
    });
    newTeam.players.splice(
      lineStart,
      sourceLineReordered.length,
      ...sourceLineReordered
    );
  }
  // substitutes
  newTeam.players.splice(11, 4, ...sourceTeam.players.slice(11, 15));
  return newTeam;
}

/**
 * Starting lineup line, according to position.
 */
function extractLineSparse(team: TeamInfo, pos: EnumPosition) {
  const tactic = team.tactic;
  const lineSize = tactic.calcLineSize(pos);
  const lineStart = tactic.calcStartOfLine(pos);
  return team.players.slice(lineStart, lineStart + lineSize);
}

function extractLine(team: TeamInfo, pos: EnumPosition): PlayerClub[] {
  return extractLineSparse(team, pos).filter((elem) => !!elem.id);
}

export function buildEmptyTeam(tactic: TacticDescriptor): TeamInfo {
  const retValue = {
    players: [] as PlayerClub[],
    tactic,
  };
  const emptySlot: PlayerClub = {
    orden: 0,
    titular: true,
    capitan: false,
  };

  retValue.players = [...Array(15).keys()].map((elem, ix) => {
    return {
      ...emptySlot,
      orden: ix,
      titular: ix <= 10,
    };
  });

  return retValue;
}

export function resolverTeamBalance(
  newTeamDraft: ResponseGetInitDraftTeam | ResponseArmaEquipoGrabar,
  isGetDataInit: boolean,
  stateTournamentPrice: Optional<number>
) {
  const isInitialBalanceTeam = 'presupuestoTorneo' in newTeamDraft;

  if (newTeamDraft.equipoBorrador) {
    if (isInitialBalanceTeam && isGetDataInit) {
      const { presupuestoTorneo } = newTeamDraft;

      return {
        tournamentPrice: presupuestoTorneo,
        balance: presupuestoTorneo - newTeamDraft.equipoBorrador.importeTotal,
      };
    } else {
      const tournamentPrice = stateTournamentPrice ?? 0;

      return {
        balance: tournamentPrice - newTeamDraft.equipoBorrador.importeTotal,
      };
    }
  }

  return null;
}
